<template>
	<el-tabs v-model="activeName" type="card">
		<el-tab-pane label="Template" name="first">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="filters" label-width="100px">
						<!--<el-form-item label="Status">
							<el-select v-model="filters.nType" placeholder="">
								<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>-->
						<el-form-item><el-button type="primary" v-on:click="addTemplateFlag = true">Add</el-button></el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-table ref="multipleTable" :data="tableData" @row-click="toDetail" tooltip-effect="dark" style="width: 100%">
						<el-table-column prop="sTemplateName" label="Template  Name"></el-table-column>
						<el-table-column prop="dTime" label="Create Time"></el-table-column>
						<el-table-column prop="sName" label="Create User"></el-table-column>
						<el-table-column prop="sTableName" label="Table Name">
							<template slot-scope="scope">
								{{ scope.row.sSchema }}.{{ scope.row.sTableName }}
							</template>
						</el-table-column>
						<el-table-column prop="nUploadCnt" label="Uploads"></el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24">
					<div style="float: right;margin-top:20px;">
						<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :total="total"></el-pagination>
					</div>
				</el-col>
			</el-row>
			<el-dialog title="Add Template" :visible.sync="addTemplateFlag" width="80%">
				<div>
					<el-form :model="form" ref="form" label-width="160px">
						<el-form-item label="File Name" prop="sFileName">
							<el-input v-model="form.sFileName" readonly disabled placeholder="Please select .csv" style="width:220px;"></el-input>
							<el-button class="upload-button">
								Select
								<input @change="changeFile" id="files" type="file" />
							</el-button>
						</el-form-item>
						<el-form-item label="Template Name" prop="sTemplateName" v-if="form.sFileName">
							<el-input v-model="form.sTemplateName" placeholder="" style="width:220px;"></el-input>
						</el-form-item>
						<el-form-item label="Schema" prop="sSchema" v-if="form.sFileName">
							<el-select v-model="form.sSchema" placeholder="Select">
								<el-option v-for="item in options1" :key="item.name" :label="item.sSchema" :value="item.sSchema"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Table Name" prop="sTableName" v-if="form.sFileName">
							<el-input v-model="form.sTableName" placeholder="" style="width:220px;"></el-input>
						</el-form-item>
						<el-form-item label="Column Name." prop="sColumnName" v-for="(item,index) in ziduanList" :key="index" v-if="form.sFileName && item.sFieldName !== 'LOAD_DT'">
							<el-input v-model="item.sFieldName" style="width:220px;" disabled readonly placeholder=""></el-input>
							<label>Column Type.</label>
							<el-select v-model="item.sFieldType" placeholder="Select" @change="changeSelect(item)">
								<el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<el-input v-model="item.sLen" style="width:140px;" v-if="item.sFieldType == 'nvarchar' || item.sFieldType == 'decimal'" placeholder="length"></el-input>

							<el-select v-model="item.sIfnull" placeholder="Select">
								<el-option v-for="item in options3" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<template v-if="item.sIfnull == 1">
								<el-button v-if="item.typeF == 0" @click="item.typeF = 1">+</el-button>
								<template v-if="item.typeF == 1">
									<el-select v-model="item.sIfcheckValue" placeholder="Select">
										<el-option v-for="item in options4" :key="item.id" :label="item.name" :value="item.id"></el-option>
									</el-select>
									<el-select v-model="item.sValueRange" v-if="item.sIfcheckValue == 1" placeholder="Select">
										<el-option v-for="item in options5" :key="item.nId" :label="item.sRuleName" :value="item.nId"></el-option>
									</el-select>
									<el-input v-model="item.sValueRange" v-else style="width:220px;" placeholder=""></el-input>
									<el-button
										@click="
											item.typeF = 0;
											item.sIfcheckValue = '0';
											item.sValueRange = '';
										"
									>
										-
									</el-button>
								</template>
							</template>
							<!--<el-checkbox v-model="item.nPrimaryKey" border>pramiry</el-checkbox>-->
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button
						@click="
							addTemplateFlag = false;
							resetFrom();
						"
					>
						Cancel
					</el-button>
					<el-button type="primary" @click="saveTemplate0">Confirm</el-button>
				</span>
			</el-dialog>
			<el-dialog title="View Template" :visible.sync="detailViewFlag" width="80%">
				<div>
					<el-form :model="detailForm" ref="form" label-width="160px">
						<el-form-item label="Template Name" prop="sTemplateName">{{ detailForm.sTemplateName }}</el-form-item>
						<el-form-item label="Schema" prop="sSchemaName">{{ detailForm.sSchema }}</el-form-item>
						<el-form-item label="Table Name" prop="sTemplateName">{{ detailForm.sTableName }}</el-form-item>
						<el-form-item label="Column Name." prop="sSchemaName" v-for="(item, index) in detailForm.ziduanList" :key="index" v-if="item.sFieldName !== 'LOAD_DT'">
							<label>{{ item.sFieldName }}</label>
							<label>&nbsp;&nbsp;&nbsp;</label>
							{{ item.sFieldType }}
							<label v-if="item.sLen">({{ item.sLen }})</label>
							<label>&nbsp;&nbsp;&nbsp;</label>
							<label v-if="item.nPrimaryKey == 1">Primary Key</label>

							<label>{{ toConvit1(item.sIfnull, options3) }}</label>
							<label>&nbsp;&nbsp;&nbsp;</label>
							<template v-if="item.sIfnull == 1">
								<label>{{ toConvit3(item.sIfcheckValue, options4) }}</label>
								<label>&nbsp;&nbsp;&nbsp;</label>
								<label v-if="item.sIfcheckValue == 1">{{ toConvit2(item.sValueRange, options5) }}</label>
								<label v-else>{{ item.sValueRange }}</label>
							</template>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="detailViewFlag = false">Cancel</el-button>
					<el-button
						type="primary"
						@click="
							detailViewFlag = false;
							EditTemplateFlag = true;
						"
					>
						Edit
					</el-button>
				</span>
			</el-dialog>
			<el-dialog title="Edit Template" :visible.sync="EditTemplateFlag" width="80%">
				<div>
					<el-form :model="detailForm" ref="detailForm" label-width="160px">
						<el-form-item label="Template Name" prop="sTemplateName">
							<el-input v-model="detailForm.sTemplateName" placeholder="" style="width:220px;"></el-input>
						</el-form-item>
						<el-form-item label="Schema" prop="sSchema">
							<el-select v-model="detailForm.sSchema" placeholder="Select">
								<el-option v-for="item in options1" :key="item.name" :label="item.sSchema" :value="item.sSchema"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Table Name" prop="sTableName"><el-input v-model="detailForm.sTableName" placeholder="" style="width:220px;"></el-input></el-form-item>
						<el-form-item
							label="Column Name."
							prop="sColumnName"
							v-for="(item, index) in detailForm.ziduanList" :key="index"
							v-if="item.isDelete == 0 && item.sFieldName !== 'LOAD_DT'"
						>
							<el-input v-model="item.sFieldName" style="width:220px;" placeholder=""></el-input>
							<label>Column Type.</label>
							<el-select :disabled="item.nPrimaryKey" v-model="item.sFieldType" placeholder="Select" @change="changeSelect(item)">
								<el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<el-input
								:disabled="item.nPrimaryKey"
								v-model="item.sLen"
								style="width:140px;"
								v-if="item.sFieldType == 'nvarchar' || item.sFieldType == 'decimal'"
								placeholder="length"
							></el-input>
							<el-select v-model="item.sIfnull" placeholder="Select">
								<el-option v-for="item in options3" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<template v-if="item.sIfnull == 1">
								<el-button v-if="item.typeF == 0" @click="item.typeF = 1">+</el-button>
								<template v-if="item.typeF == 1">
									<el-select v-model="item.sIfcheckValue" placeholder="Select">
										<el-option v-for="item in options4" :key="item.id" :label="item.name" :value="item.id"></el-option>
									</el-select>
									<el-select v-model="item.sValueRange" v-if="item.sIfcheckValue == 1" placeholder="Select">
										<el-option v-for="item in options5" :key="item.nId" :label="item.sRuleName" :value="item.nId"></el-option>
									</el-select>
									<el-input v-model="item.sValueRange" v-else style="width:220px;" placeholder=""></el-input>
									<el-button
										@click="
											item.typeF = 0;
											item.sIfcheckValue = '0';
											item.sValueRange = '';
										"
									>
										-
									</el-button>
								</template>
							</template>
							<!--<el-checkbox disabled="disabled" v-model="item.nPrimaryKey" border>pramiry</el-checkbox>-->
							<el-button :disabled="item.nPrimaryKey" @click="deleteOne(index)">Delete</el-button>
							<el-button @click="addOne(index)" v-if="index == 0">Add</el-button>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button
						@click="
							EditTemplateFlag = false;
							resetFrom();
						"
					>
						Cancel
					</el-button>
					<el-button type="primary" @click="updateTemplate">Save</el-button>
				</span>
			</el-dialog>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import { selectUploadTemplatePage, selectTemplateFieldList, modifyTemplate, saveTemplate, getDatabaseInfoList, getCurrencyCheckRulePage } from '../../api/api';
export default {
	data() {
		return {
			activeName: 'first',
			addTemplateFlag: false,
			detailViewFlag: false,
			EditTemplateFlag: false,
			step: 1,
			filters: {
				pageSize: 10,
				currentPage: 1
			},
			options1: [],
			options2: [
				{
					id: 'int',
					name: 'int'
				},
				{
					id: 'decimal',
					name: 'decimal'
				},
				{
					id: 'nvarchar',
					name: 'nvarchar'
				},
				{
					id: 'datetime',
					name: 'datetime'
				}
			],
			options3: [
				{
					id: '0',
					name: 'Null Able'
				},
				{
					id: '1',
					name: 'Not Null'
				}
			],
			options4: [
				{
					id: '1',
					name: 'Using'
				},
				{
					id: '2',
					name: '='
				},
				{
					id: '3',
					name: 'In'
				}
			],
			options5: [],
			form: {
				sFileName: '',
				sTemplateName: '',
				sSchema: '',
				sTableName: ''
			},
			detailForm: {
				ziduanList: []
			},
			ziduanList: [],
			total: 0,
			tableData: []
		};
	},
	mounted() {
		this.getList();

		getDatabaseInfoList({
			currentPage: 1,
			pageSize: 9999
		}).then(res => {
			this.options1 = res.data;
		});
		getCurrencyCheckRulePage({
			currentPage: 1,
			pageSize: 9999
		}).then(res => {
			this.options5 = res.data;
		});
	},
	methods: {
		toConvit3(val, arr) {
			if (val == 0) {
				return;
			}
			const one = arr.find(one => one.id == val);
			if (one) {
				return one.name;
			}
		},
		toConvit1(val, arr) {
			const one = arr.find(one => one.id == val);
			if (one) {
				return one.name;
			}
		},
		toConvit2(val, arr) {
			const one = arr.find(one => one.nId == val);
			if (one) {
				return one.sRuleName;
			}
		},
		resetFrom() {
			this.form = {
				sFileName: '',
				sTemplateName: '',
				sSchema: '',
				sTableName: ''
			};
			this.ziduanList = [];
			this.detailForm = {
				ziduanList: []
			};
		},
		changeSelect(item) {
			if (item.sFieldType == 'decimal') {
				item.sLen = '10,2';
			} else if (item.sFieldType == 'nvarchar') {
				item.sLen = '500';
			} else {
				item.sLen = '';
			}
		},
		saveTemplate0() {
			if (!this.form.sTemplateName) {
				this.$message.error('Please enter the template name');
				return;
			}
			if (!this.form.sSchema) {
				this.$message.error('Please select the schema');
				return;
			}
			if (!this.form.sTableName) {
				this.$message.error('Please enter the table name');
				return;
			}
			var arr = [];
			var flagPrimary = false;
			var flagFieldName = false;
			var sFieldType = false;
			var sameKeyFlag = false;
			var smaeKeyObj = {};
			var sLenFlag = false;
			var sLenTypeFlag = false;
			this.ziduanList.forEach(one => {
				if (one.nPrimaryKey == true) {
					flagPrimary = true;
				}
				if (one.sFieldName == '') {
					flagFieldName = true;
				}
				if (one.sFieldType == '') {
					sFieldType = true;
				}
				if (!smaeKeyObj[one.sFieldName]) {
					smaeKeyObj[one.sFieldName] = 1;
				} else {
					sameKeyFlag = true;
				}

				if (one.sFieldType == 'nvarchar') {
					if (one.sLen == '') {
						sLenFlag = true;
					}
					if (!/^\d*$/.test(one.sLen)) {
						sLenTypeFlag = true;
					}
					arr.push({
						sFieldName: one.sFieldName,
						nOrder: one.nOrder,
						sFieldType: one.sFieldType + '(' + one.sLen + ')',
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				} else if (one.sFieldType == 'decimal') {
					if (one.sLen == '') {
						sLenFlag = true;
					}
					if (one.sLen.indexOf(',') == -1) {
						sLenTypeFlag = true;
					}
					arr.push({
						sFieldName: one.sFieldName,
						nOrder: one.nOrder,
						sFieldType: one.sFieldType + '(' + one.sLen + ')',
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				} else {
					arr.push({
						sFieldName: one.sFieldName,
						nOrder: one.nOrder,
						sFieldType: one.sFieldType,
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				}
			});
			//				if(flagPrimary == false) {
			//					this.$message.error('Please set primary key');
			//					return;
			//				}
			if (flagFieldName == true) {
				this.$message.error('Please input key name');
				return;
			}
			if (sFieldType == true) {
				this.$message.error('Please select field type');
				return;
			}
			if (sameKeyFlag == true) {
				this.$message.error('Field name duplicate');
				return;
			}
			if (sLenFlag == true) {
				this.$message.error('Please input Field length ');
				return;
			}
			if (sLenTypeFlag == true) {
				this.$message.error('Field type format error ');
				return;
			}
			saveTemplate({
				sTemplateName: this.form.sTemplateName,
				sSchema: this.form.sSchema,
				sTableName: this.form.sTableName,
				templateFieldList: arr
			}).then(res => {
				this.$refs.form.resetFields();
				this.getList();
				this.$message('add Success');
				this.addTemplateFlag = false;
			});
		},
		updateTemplate() {
			if (!this.detailForm.sTemplateName) {
				this.$message.error('Please enter the template name');
				return;
			}
			if (!this.detailForm.sSchema) {
				this.$message.error('Please select the schema');
				return;
			}
			if (!this.detailForm.sTableName) {
				this.$message.error('Please enter the table name');
				return;
			}
			var arr = [];
			var flagPrimary = false;
			var flagFieldName = false;
			var sFieldType = false;
			var sameKeyFlag = false;
			var smaeKeyObj = {};
			var sLenFlag = false;
			var sLenTypeFlag = false;
			this.detailForm.ziduanList.forEach(one => {
				if (one.nPrimaryKey == true) {
					flagPrimary = true;
				}
				if (one.sFieldName == '') {
					flagFieldName = true;
				}
				if (one.sFieldType == '') {
					sFieldType = true;
				}
				if (!smaeKeyObj[one.sFieldName]) {
					smaeKeyObj[one.sFieldName] = 1;
				} else {
					sameKeyFlag = true;
				}

				if (one.sFieldType == 'nvarchar') {
					if (one.sLen == '') {
						sLenFlag = true;
					}
					if (!/^\d*$/.test(one.sLen)) {
						sLenTypeFlag = true;
					}
					arr.push({
						sFieldName: one.isDelete == 1 ? '' : one.sFieldName,
						nOrder: one.nOrder,
						sOldFieldName: one.sOldFieldName,
						sFieldType: one.sFieldType + '(' + one.sLen + ')',
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				} else if (one.sFieldType == 'decimal') {
					if (one.sLen == '') {
						sLenFlag = true;
					}
					if (one.sLen.indexOf(',') == -1) {
						sLenTypeFlag = true;
					}
					arr.push({
						sFieldName: one.isDelete == 1 ? '' : one.sFieldName,
						nOrder: one.nOrder,
						sOldFieldName: one.sOldFieldName,
						sFieldType: one.sFieldType + '(' + one.sLen + ')',
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				} else {
					arr.push({
						sFieldName: one.isDelete == 1 ? '' : one.sFieldName,
						nOrder: one.nOrder,
						sOldFieldName: one.sOldFieldName,
						sFieldType: one.sFieldType,
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				}
			});

			//				if(flagPrimary == false) {
			//					this.$message.error('Please set primary key');
			//					return;
			//				}
			if (flagFieldName == true) {
				this.$message.error('Please input key name');
				return;
			}
			if (sFieldType == true) {
				this.$message.error('Please select field type');
				return;
			}
			if (sameKeyFlag == true) {
				this.$message.error('Field name duplicate');
				return;
			}
			if (sLenFlag == true) {
				this.$message.error('Please input Field length ');
				return;
			}
			if (sLenTypeFlag == true) {
				this.$message.error('Field type format error ');
				return;
			}
			modifyTemplate({
				nTemplateId: this.detailForm.nTemplateId,
				sTemplateName: this.detailForm.sTemplateName,
				sSchema: this.detailForm.sSchema,
				sTableName: this.detailForm.sTableName,
				templateFieldList: arr
			}).then(res => {
				this.$refs.detailForm.resetFields();
				this.getList();
				this.EditTemplateFlag = false;
				this.$message('update Success');
				this.detailViewFlag = false;
			});
		},
		deleteOne(index) {
			this.detailForm.ziduanList[index]['isDelete'] = 1;
		},
		addOne() {
			if (this.detailForm.ziduanList.length == 0) {
				this.detailForm.ziduanList.push({
					sFieldName: '',
					sOldFieldName: '',
					sFieldType: '',
					sLen: '',
					sIfnull: '0',
					typeF: 0,
					sIfcheckValue: '',
					sValueRange: '',
					nOrder: 1,
					nPrimaryKey: false,
					isDelete: 0
				});
			} else {
				this.detailForm.ziduanList.push({
					sFieldName: '',
					sOldFieldName: '',
					sFieldType: '',
					sLen: '',
					sIfnull: '0',
					typeF: 0,
					sIfcheckValue: '',
					sValueRange: '',
					nOrder: this.detailForm.ziduanList[this.detailForm.ziduanList.length - 1]['nOrder'] * 1 + 1,
					nPrimaryKey: false,
					isDelete: 0
				});
			}
		},
		handleCurrentChange(page) {
			this.filters.currentPage = page;
			this.getList();
		},
		changeFile(e) {
			var self = this;
			var files = document.getElementById('files').files;
			var reg = new RegExp('.*,".*,.*"$');
			if (files.length) {
				var file = files[0];
				self.form.sFileName = file.name;
				var arr = file.name.split('.');
				if ('csv'.indexOf(arr[arr.length - 1]) === -1) {
					self.$message({
						message: 'Please Select csv.',
						type: 'error',
						duration: 5 * 1000
					});
				}
				var reader = new FileReader();
				if (typeof FileReader == 'undefined') {
					self.$message({
						message: 'Your browser does not support FileReader interface',
						type: 'error',
						duration: 5 * 1000
					});
					return;
				}
				reader.readAsText(file);
				reader.onload = function(val) {
					var relArr = this.result.split('\r\n');
					if (relArr.length > 0) {
						var values = relArr[0];
						if (reg.test(values)) {
							self.$message({
								message: 'There are English commas in the content of the file. Please upload it after modification. The content with English commas is：' + values,
								type: 'error',
								duration: 5 * 1000
							});
							return;
						}
						var objArr = values.split(',');
						for (var i = 0, len = objArr.length; i < len; i++) {
							if (!!objArr[i]) {
								self.ziduanList.push({
									sFieldName: objArr[i],
									sFieldType: 'nvarchar',
									sLen: '500',
									sIfnull: '0',
									typeF: 0,
									sIfcheckValue: '',
									sValueRange: '',
									nOrder: i + 1,
									nPrimaryKey: false
								});
							}
						}
						self.ziduanList.push({
							sFieldName: 'LOAD_DT',
							sFieldType: 'nvarchar',
							sLen: '500',
							sIfnull: '0',
							typeF: 0,
							sIfcheckValue: '',
							sValueRange: '',
							nOrder: i + 1,
							nPrimaryKey: false
						});
						document.getElementById('files').value = '';
					} else {
						self.$message({
							message: 'Empty File',
							type: 'error',
							duration: 5 * 1000
						});
						return;
					}
				};
			}
		},
		toDetail(data) {
			selectTemplateFieldList({
				nTemplateId: data.nTemplateId
			}).then(res => {
				var ziduanList = [];
				res.data.forEach(one => {
					if (!one.templateFieldCheck) {
						one.templateFieldCheck = {
							sIfnull: '0',
							typeF: 0,
							sIfcheckValue: '',
							sValueRange: ''
						};
					} else {
						one.templateFieldCheck.sIfcheckValue = one.templateFieldCheck.sIfcheckValue == 0 ? '' : one.templateFieldCheck.sIfcheckValue;
					}
					if (one.sFieldType.indexOf('nvarchar') > -1) {
						ziduanList.push({
							sFieldName: one.sFieldName,
							sOldFieldName: one.sFieldName,
							sFieldType: 'nvarchar',
							sLen: one.sFieldType.replace(/nvarchar\(/gi, '').replace(/\)/gi, ''),
							nOrder: one.nOrder,
							nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
							isDelete: 0,
							sIfnull: one.templateFieldCheck.sIfnull,
							typeF: one.templateFieldCheck.sIfcheckValue == '' ? 0 : 1,
							sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
							sValueRange: one.templateFieldCheck.sValueRange
						});
					} else if (one.sFieldType.indexOf('decimal') > -1) {
						ziduanList.push({
							sFieldName: one.sFieldName,
							sOldFieldName: one.sFieldName,
							sFieldType: 'decimal',
							sLen: one.sFieldType.replace(/decimal\(/gi, '').replace(/\)/gi, ''),
							nOrder: one.nOrder,
							nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
							isDelete: 0,
							sIfnull: one.templateFieldCheck.sIfnull,
							typeF: one.templateFieldCheck.sIfcheckValue == '' ? 0 : 1,
							sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
							sValueRange: one.templateFieldCheck.sValueRange
						});
					} else {
						ziduanList.push({
							sFieldName: one.sFieldName,
							sOldFieldName: one.sFieldName,
							sFieldType: one.sFieldType,
							sLen: '',
							nOrder: one.nOrder,
							nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
							isDelete: 0,
							sIfnull: one.templateFieldCheck.sIfnull,
							typeF: one.templateFieldCheck.sIfcheckValue == '' ? 0 : 1,
							sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
							sValueRange: one.templateFieldCheck.sValueRange
						});
					}
				});

				this.detailForm = {
					nTemplateId: data.nTemplateId,
					sTemplateName: data.sTemplateName,
					sSchema: data.sSchema,
					sTableName: data.sTableName,
					ziduanList: ziduanList
				};
				this.detailViewFlag = true;
			});
		},
		reGetList: function() {
			this.filters.currentPage = 1;
			this.getList();
		},
		getList: function() {
			var param = Object.assign({}, this.filters);
			selectUploadTemplatePage(param).then(res => {
				this.tableData = res.data;
				this.total = res.page.totalCount * 1;
			});
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
.upload-button {
	position: relative;
	input {
		position: absolute;
		opacity: 0;
		width: 100%;
		height: 100%;
		z-index: 10;
		top: 0;
		left: 0;
	}
}
</style>



// WEBPACK FOOTER //
// template.vue?accaa018